import React from 'react';
import { DataTable, Icon, Span } from '../widgets';

const OrganizationRow = (props) => {
    const { organization, farmAssigned, serialNumber,
        handleEditModal, handleDeleteModal, isAllowDelete, isAllowEdit } = props;

    return (<>
        <DataTable.Row>
            <DataTable.Cell style={{ width: "40px" }}>{serialNumber}</DataTable.Cell>
            <DataTable.Cell>{organization.organization_category_name}</DataTable.Cell>
            <DataTable.Cell>{organization.organization_name}</DataTable.Cell>
            {(isAllowEdit || isAllowDelete) && <DataTable.Cell className="center">
                {<> {isAllowEdit && <Icon
                    className="fa fa-pencil mr-1 cursor-pointer"
                    title="Edit"
                    onClick={() => handleEditModal(organization.organization_uuid, organization.organization_name, organization.organization_category_id)} />}
                    {isAllowDelete && <Span className="btn-icon" >
                        <i className="fa fa-trash"
                            title="Delete"
                            style={{ cursor: `${farmAssigned ? "not-allowed" : "pointer"}` }}
                            onClick={farmAssigned ? null :
                                () => handleDeleteModal(organization.organization_uuid, organization.organization_name)}
                        />
                    </Span>}
                </>}
            </DataTable.Cell>}
        </DataTable.Row>
    </>
    );
}

export default OrganizationRow;
